// Game-related constants
export const GAME_TYPES = {
  FOOTBALL: 'football',
  NBA: 'nba',
  BASEBALL: 'baseball',
};

// Game display names
export const GAME_DISPLAY_NAMES = {
  [GAME_TYPES.FOOTBALL]: 'Football',
  [GAME_TYPES.NBA]: 'NBA',
  [GAME_TYPES.BASEBALL]: 'Baseball',
};

// Default game type
export const DEFAULT_GAME_TYPE = GAME_TYPES.FOOTBALL;
